import { render, staticRenderFns } from "./shFaceAuth.vue?vue&type=template&id=70c1e174&scoped=true&"
import script from "./shFaceAuth.vue?vue&type=script&lang=js&"
export * from "./shFaceAuth.vue?vue&type=script&lang=js&"
import style0 from "./shFaceAuth.vue?vue&type=style&index=0&id=70c1e174&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c1e174",
  null
  
)

export default component.exports